import styled from 'styled-components';

export default styled.div`
  flex-direction: column;
  padding-top: 10%;
  width: 390px;
`;



// WEBPACK FOOTER //
// ./src/components/FetchComponent/Components/Style/index.js